import {useLazyQuery} from '@apollo/client'
import {useSearchParams} from 'react-router-dom'
import {GET_CUSTOMER_DOCUMENTS} from '../../../utils/GraphQLAPI'
import {Col, Container, Row} from 'react-bootstrap'
import {KTCard} from '../../../_metronic/helpers'
import PdfViewer from '../../sharedComponent/viewer/PDFViewer'
import {AES, enc} from 'crypto-js'
import {useEffect, useState} from 'react'
import {downloadFilesFromS3} from '../../../utils/helper'
import {renderFileHeader} from '../../../utils/Contract/ContractUtils'
import SkeletonLoader from '../../sharedComponent/Skeleton'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'

const EnrollmentDocuments = () => {
  const [queryParams] = useSearchParams()
  const [documents, setDocuments] = useState<any>([])
  const [getDocuments, {loading: documentsLoading}] = useLazyQuery(GET_CUSTOMER_DOCUMENTS, {
    onCompleted: (data) => setDocuments(data),
  })

  //effects
  useEffect(() => {
    const urlParams: any = queryParams.get('pincode')
    const decryptedData = JSON.parse(
      AES.decrypt(urlParams.replaceAll(' ', '+'), 'gDdoxYdfT5XCJw0y').toString(enc.Utf8)
    )
    getDocuments({
      variables: {
        pincode: decryptedData?.pincode,
        tpvId: decryptedData?.tpvId,
        clientId: decryptedData?.clientId,
      },
    })
  }, [])
  //handlers

  const handleDownloadFiles = async () => {
    documents?.getCustomerDocuments.forEach((file: any) => {
      const fileName = `${renderFileHeader(file?.position).replaceAll(' ', '-')}`
      downloadFilesFromS3(file?.fileUrl, fileName)
    })
  }
  if (documentsLoading) {
    return <SkeletonLoader />
  }
  if (documents) {
    return (
      <Container>
        <KTCard className='py-7'>
          <h3 className='text-center'>
            Hi, your enrollment is completed. Please checkout the contract and enrollment related
            files below.
          </h3>
          {documents?.getCustomerDocuments?.length && (
            <div className='text-center'>
              <button className='btn btn-primary' onClick={() => handleDownloadFiles()}>
                Download All files
              </button>
            </div>
          )}
          <Container>
            <Row>
              {documents?.getCustomerDocuments?.length &&
                documents?.getCustomerDocuments
                  ?.filter((file: any) => file.position === 3)
                  ?.map((url: any) => (
                    <Col lg={6} key={url?.fileUrl} className='mb-3'>
                      <p className='fs-4 fw-bold my-5'>Contract</p>
                      <PdfViewer
                        url={url?.fileUrl}
                        previewSettings={GLOBAL_CONSTANTS.previewSettings}
                      />
                    </Col>
                  ))}
              {documents?.getCustomerDocuments?.length ? (
                documents?.getCustomerDocuments
                  ?.filter((files: any) => files.position !== 3)
                  ?.map((url: any) => {
                    return (
                      <Col lg={6} key={url?.fileUrl} className='mb-3'>
                        <p className='fs-4 fw-bold my-5'>{renderFileHeader(url?.position)}</p>
                        <PdfViewer
                          url={url?.fileUrl}
                          previewSettings={GLOBAL_CONSTANTS.previewSettings}
                        />
                      </Col>
                    )
                  })
              ) : (
                <div className='text-center'>No files found</div>
              )}
            </Row>
          </Container>
        </KTCard>
      </Container>
    )
  }
  return (
    <Container>
      <div className='text-center alert alert-danger mt-5'>
        <h4 className='fs7'> Oops!, Something went wrong!</h4>
      </div>
    </Container>
  )
}
export default EnrollmentDocuments
